<template>
    <div>
        <hr>
        <strong>Customer</strong>
        <br>
        <div class="row">
            <div class="col-md-6">
                <label class="d-block">
                    <strong>Email</strong><i v-if="isVerifyingEmail" class="mdi mdi-spin mdi-loading text-gray-500"></i>
                    <input v-model="customer.email" class="form-control" type="text" name="customer.email">
                    <small class="text-danger" v-if="emailValidationMessage">{{ emailValidationMessage }}</small>
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
            <small class="text-success" v-if="customerInformationMessage !== null" style="white-space: pre-line;">{{ customerInformationMessage }}</small>
        <button type="button" v-if="customerInformationMessage" class="btn btn-primary btn-sm"
                v-on:click="fillCustomerInfo">Fill
        </button>
            </div>
        </div>
        <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>First name</strong>
                <input v-model="customer.firstName" class="form-control" type="text" name="customer.first_name">
            </label>
        </div>
        <div class="col-md-6">
            <label class="d-block">
                <strong>Last name</strong>
                <input v-model="customer.lastName" class="form-control" type="text" name="customer.last_name">
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>Date of birth</strong>
                <flat-pickr
                        v-model="customer.birthDate"
                        class="form-control form-control-sm d-inline-block mr-1"
                        placeholder="Select birthdate"
                        name="customer.birth_date"
                        :config="datePickerConfig">
                </flat-pickr>
            </label>
        </div>
        <div class="col-md-6">
            <label class="d-block">
                <strong>Phone</strong>
                <input v-model="customer.phoneNumber" class="form-control" type="text" name="customer.phone_number">
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>Nationality</strong>
                <country-code-selector v-on:country-selected="onNationalitySelected"
                                       form-field-name="customer_nationality"
                                       :prefilledCountryCode="nationality"></country-code-selector>
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>Country</strong>
                <country-code-selector v-on:country-selected="onCountrySelected"
                                       form-field-name="customer_country_code"
                                       :prefilledCountryCode="country"></country-code-selector>
            </label>
        </div>
        <div class="col-md-6">
            <label class="d-block">
                <strong>Address line 1</strong> <small>(optional)</small>
                <input v-model="customer.address.addressLine1" class="form-control" type="text"
                       name="customer.address_line_1">
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>Address line 2</strong> <small>(optional)</small>
                <input v-model="customer.address.addressLine2" class="form-control" type="text"
                       name="customer.address_line_2">
            </label>
        </div>
        <div class="col-md-6">
            <label class="d-block">
                <strong>Zip code</strong> <small>(optional)</small>
                <input v-model="customer.address.zipCode" class="form-control" type="text" name="customer.zip_code">
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>City</strong> <small>(optional)</small>
                <input v-model="customer.address.city" class="form-control" type="text" name="customer.city">
            </label>
        </div>
        <div class="col-md-6">
            <label class="d-block">
                <strong>Gender</strong> <small>(optional)</small>
                <select v-model="customer.gender" class="form-control" type="text" name="customer.gender">
                    <option value=""></option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                </select>
            </label>
        </div>
    </div>
    <div v-if="!isEquipoOrder" class="row">
        <div class="col-md-6">
            <label class="d-block">
                <strong>Customer reference</strong> <small>(optional)</small>
                <input v-model="customerReference" class="form-control" type="text" name="customer_reference">
            </label>
        </div>
    </div>
    <br>
    <input type="checkbox" id="is_booking_for_someone_else" name="is_booking_for_someone_else"
           v-model="isBookingForSomeoneElse">
    <label for="is_booking_for_someone_else">Booking for someone else</label>
    <div v-if="isBookingForSomeoneElse">
        <div class="row">
            <div class="col-md-6">
                <div class="d-block">
                    <strong>Traveller 1</strong>
                    <order-traveller-form v-on:traveller-updated="onTravellerUpdated"
                                          :prefilled-first-name="prefilledTravellers[0] ? prefilledTravellers[0].firstName : ''"
                                          :prefilled-last-name="prefilledTravellers[0] ? prefilledTravellers[0].lastName : ''"
                                          :prefilled-nationality="prefilledTravellers[0] ? prefilledTravellers[0].nationality : ''"
                                          :traveller-index="0"></order-traveller-form>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div v-if="(travellerDataRequired || isBlacklistedNationalityCodesAvailable) && travellerCount > 0">
        <div class="row" v-for="(_, index) in travellerCount">
            <div class="col-md-6" v-if="index !== 0">
                <div class="d-block">
                    <strong>Traveller {{ index + 1 }}</strong>
                    <order-traveller-form v-on:traveller-updated="onTravellerUpdated"
                                          :prefilled-first-name="prefilledTravellers[index] ? prefilledTravellers[index].firstName : ''"
                                          :prefilled-last-name="prefilledTravellers[index] ? prefilledTravellers[index].lastName : ''"
                                          :prefilled-nationality="prefilledTravellers[index] ? prefilledTravellers[index].nationality : ''"
                                          :traveller-index="index"></order-traveller-form>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import FlatPickr from 'vue-flatpickr-component/src/component';
import CountryCodeSelector from "./CountryCodeSelector.vue";
import OrderTravellerForm from "./OrderTravellerForm.vue";

export default {
    name: "ManualOrderB2c",
    components: {CountryCodeSelector, FlatPickr, OrderTravellerForm},
    props: [
        'travellerDataRequired',
        'isBlacklistedNationalityCodesAvailable',
        'onTravellerUpdated',
        'isEquipoOrder',
        'customer',
        'emailValidationMessage',
        'onCountrySelected',
        'customerReference',
        'prefilledTravellers',
        'travellerCount',
        'isBookingForSomeoneElse',
        'isVerifyingEmail',
        'onNationalitySelected',
        'nationality',
        'country',
        'prefilledCountryCode',
        'customerInformationMessage',
        'fillCustomerInfo'
    ],
    data() {
        return {
            datePickerConfig: {
                minDate: '1910-01-01',
            }
        };
    },
};
</script>
